import { formatISO } from "date-fns";
import { caseTypeOptions, practicesOptions, stateOfPIPsOptions, umPolicyLimitsOptions } from "./systemData";

import { redirect } from "react-router-dom";
import { getDaysDifference } from "./dateScripts";
import { tabs_button } from "../assets/data";
import { isPrimaryInsurance } from "./primaryItemScripts";
import { getUMReducedAmountClean } from "./misc";
import { format } from "date-fns";
import { diffCalendarDays, formatApiDateEnUs, formatApiDateTimeEnUsNoSeconds, isDateOnlyString, parseApiDateOrDateTime } from "./dateParsing";

export function simplifyDate(date) {
    const d = parseApiDateOrDateTime(date)
    if (!d) return null
    return d.toLocaleDateString('en-US', {
        day: '2-digit',
        month: 'long',
    })
}

export function truncateString(str, len) {
    if (str && len) {
        return str.substring(0, len) + ((str.length > len) ? '...' : '')
    }
    
    return null
}


function subtractYears(date, years) {
    date.setFullYear(date.getFullYear() - years);
    return date;
}
export function isPersonAMinor(dob) {
    let date = new Date()

    let minimum = subtractYears(date, 18)

    const parsedDob = parseApiDateOrDateTime(dob)
    if (parsedDob && parsedDob < minimum) {
        return false
    } else {
        return true
    }
}

export function formatDate(date) {

    if (date && date != "") {
        // Preserve API date-only semantics. `new Date("YYYY-MM-DD")` is UTC and shifts in EST/EDT.
        if (isDateOnlyString(date)) {
            return date
        }
        const parsed = parseApiDateOrDateTime(date)
        if (!parsed) return null
        return formatISO(parsed, { representation: 'date' })
    }
    
    return null
}

export function formatDateLocalRange(date) {    
    if (date) {   

        if (typeof date === "string" || typeof date === "number") {
            return formatDateLocal(date)
        } else {
            const d = new Date(date)
            const month = ("0" + (d.getMonth() + 1)).slice(-2);
            // const day = ("0" + date.getDate()).slice(-2);
            const day = d.getDate();
            const year = d.getFullYear();
            return `${month}/${day}/${year}`;
        }       

    }

    return null
}

export function formatDateLocal(date) {
    if (date) {     
        
        // original
        // return new Date(new Date(date)).toLocaleDateString('en-US')


        // return new Date(new Date(date+ 'T00:00:00')).toLocaleDateString('en-US')
        // return format(new Date(date), 'MM/dd/yyyy')

        return formatApiDateEnUs(date)
    }

    return date
}

// (legacy helper removed; use formatApiDateEnUs)



/** US-style date + 12h time; never includes seconds (avoids `toLocaleString` showing `:ss`). */
function formatDateLocalDateTimeEnUsNoSeconds(date) {
    if (!date) {
        return date
    }
    return formatApiDateTimeEnUsNoSeconds(date)
}

export function formatDateLocalWithTime(date) {
    return formatDateLocalDateTimeEnUsNoSeconds(date)
}

export function formatDateLocalWithTimeWithoutSeconds(date) {
    return formatDateLocalDateTimeEnUsNoSeconds(date)
}

export function formatDateLocalDMY(date) {
    if (date) {
        const d = parseApiDateOrDateTime(date)
        if (isNaN(d)) return null

        const day = ("0" + d.getDate()).slice(-2)
        const month = ("0" + (d.getMonth() + 1)).slice(-2)
        const year = d.getFullYear()

        return `${day}/${month}/${year}`
    }

    return null
}


export function formatTimeLocal(date) {
    if (date) {     
        const d = parseApiDateOrDateTime(date)
        if (!d) return date
        return d.toLocaleTimeString('en-US')
    }

    return date
}

export const setStorageItem = (key, value) => {      
    localStorage.setItem(key, JSON.stringify(value));
}

/** Dispatched on `window` after `recentCases` localStorage is updated from a case payload. */
export const RECENT_CASES_STORAGE_UPDATED = 'ecm-recent-cases-storage-updated'

/**
 * When case API returns `user_recent_cases`, persist it for the Recent Patients menu.
 */
export function syncRecentCasesFromCasePayload(payload) {
    if (!payload || typeof payload !== 'object' || payload.errorMessage) {
        return
    }
    if (!Object.prototype.hasOwnProperty.call(payload, 'user_recent_cases')) {
        return
    }
    const next = payload.user_recent_cases
    if (next != null && typeof next === 'object' && next.errorMessage) {
        return
    }
    setStorageItem('recentCases', next)
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(RECENT_CASES_STORAGE_UPDATED))
    }
}

export const removeStorageItem = (key) => {      
    localStorage.removeItem(key);
}

export const getItemFromStorageSimple = (key) => {
	const itemStr = localStorage.getItem(key)

	// if the item doesn't exist, return null
	if (itemStr == null || itemStr == undefined) {
        return null
	}
	const item = JSON.parse(itemStr)
	
	
	return item
}

export const getItemFromStorage = (key) => {

    if (window && window.systemSettings) {
        return window.systemSettings
    }
    // redirect('/')
	const itemStr = localStorage.getItem(key)

	// if the item doesn't exist, return null
	if (itemStr == null || itemStr == undefined) {
        return redirect('/')
	}
	const item = JSON.parse(itemStr)
	
	
	return item
}

export const getLabelFromSystemSettings = (options, id) => {
    if (options && id !== null) {
        const item = options.find(item => item.value == id)

        if (item) {
            return item.label
        }

        return null
    }

    return null
}

export const getColorFromSystemSettings = (options, id) => {
    if (options && id !== null) {
        const item = options.find(item => item.value == id)
        if (item) {
            return item.color
        }

        return null
    }

    return null
}

export const getColorCodeFromSystemSettings = (options, id) => {
    if (options && id !== null) {
        const item = options.find(item => item.value == id)

        if (item) {
            return item.color_code
        }

        return null
        
    }

    return null
}

export function phoneFormat(input) {//returns (###) ###-####
    if (input) {
        input = input.replace(/\D/g,'');
        var size = input.length;
        if (size>0) {input="("+input}
        if (size>3) {input=input.slice(0,4)+") "+input.slice(4,11)}
        if (size>6) {input=input.slice(0,9)+"-" +input.slice(9)}
        return input;
    }    
}

export function formatSSN(ssn) {
    if (ssn) {
        var val = ssn.replace(/[^\d-]/g, '');

        val = val.replace(/^(\d{3})-?(\d{1,2})/, '$1-$2');

        val = val.replace(/^(\d{3})-?(\d{2})-?(\d{1,4})/, '$1-$2-$3');

        val = val.split('').filter((val, idx) => {
            return val !== '-' || idx == 3 || idx == 6;
        }).join('');

        return val.substring(0, 11);
    }

    return null
}

export function formatCurrency(input) {
    if (input) {
        let USDollar = new Intl.NumberFormat('en-US', {
            // style: 'currency',
            // currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            trailingZeroDisplay: 'stripIfInteger'
        });
        let value = USDollar.format(input)

        return value;
    } else if (input == 0) {
        return '0.00'
    }
}

function hexToRgb(hex) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Parse r, g, b values
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return [r, g, b];
}

function getLuminance(r, g, b) {
    // Normalize the RGB values to the range 0-1
    let a = [r, g, b].map(function (v) {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });

    // Calculate the luminance
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

export function isLightColor(hex) {
    let [r, g, b] = hexToRgb(hex);
    let luminance = getLuminance(r, g, b);
    // A threshold of 0.5 is used; you can tweak it as needed
    return luminance > 0.5;
}

export function makeYearsDropdown(minYear) {
    let max = new Date().getFullYear();
    let min = minYear

    let options = []

    for (var i = max; i>=min; i--){
        var opt = {
            label: i,
            value: i
        }
        options.push(opt)
    }

    return options
}

export function getDaysSince(starting) {
    if (!starting) return 0
    const diff = diffCalendarDays(starting, new Date())
    if (diff == null || diff < 0) return 0
    return diff
}

export function isDateValid(dateStr) {
    if (dateStr instanceof Date) return !Number.isNaN(dateStr.getTime())
    return !!parseApiDateOrDateTime(dateStr)
}

export function isDateInThePast(date) {
    if (!date) return false
    const diff = diffCalendarDays(date, new Date())
    return diff != null && diff > 0
}

export function isDateTodayOrInThePast(date) {
    if (!date) return false
    const diff = diffCalendarDays(date, new Date())
    return diff != null && diff >= 0
}

export function isMajorMedSurgeryPrechecked(data) {
    if (data && data.major_meds && data.major_meds.length > 0) {
        let primary = data.major_meds.find(item => item.is_primary_insurance)

        if (primary) {
            if (primary.major_med_departments && primary.major_med_departments.length > 0) {
                let surgery = primary.major_med_departments.find(item => item.department_id == 5)

                if (surgery) {
                    return surgery.pre_auth
                }
            }
        }
    }
    return false
}

export function serviceAlreadyexistsOnOtherMajorMeds(currentMajorMed, activeCase, departmentId, serviceId) {
    let isDisabled = false

    if (currentMajorMed && activeCase && departmentId && serviceId) {
        if (activeCase.major_meds && activeCase.major_meds.length > 1) { // if there is just one major med, no reason to continue....
            let restOfMajorMeds = activeCase.major_meds.filter(item => item.id !== currentMajorMed)

            if (restOfMajorMeds && restOfMajorMeds.length > 0) {
                restOfMajorMeds.forEach(item => {
                    if (item.major_med_departments) {                  
                        let sameDepartment = item.major_med_departments.find(department => department.department_id == departmentId)
                        if (sameDepartment) { // look into the same department
                   
                            if (sameDepartment.services && sameDepartment.services.length > 0) {
                                sameDepartment.services.forEach(service => {
                                    
                                    if (service.service_id == serviceId) {
                                        if (service.status_id !== 2) { // status_id == 2 -> the service is denied, needs to appear on other majormeds
                                            isDisabled = true
                                        }
                                    }
                                })
                            }
                        }
                    }
                })
            }
        }
       
    }

    return isDisabled
}

export function surgicallreadyexistsOnOtherMajorMeds(currentMajorMed, activeCase, departmentId, surgicalId) {
    let isDisabled = false

    if (currentMajorMed && activeCase && departmentId && surgicalId) {
        if (activeCase.major_meds && activeCase.major_meds.length > 1) { // if there is just one major med, no reason to continue....
            let restOfMajorMeds = activeCase.major_meds.filter(item => item.id !== currentMajorMed)

            if (restOfMajorMeds && restOfMajorMeds.length > 0) {
                restOfMajorMeds.forEach(item => {
                    if (item.major_med_departments) {                  
                        let sameDepartment = item.major_med_departments.find(department => department.department_id == departmentId)
                        if (sameDepartment) { // look into the same department
                   
                            if (sameDepartment.surgeries && sameDepartment.surgeries.length > 0) {
                                sameDepartment.surgeries.forEach(surgery => {
                                    
                                    if (surgery.surgery_id == surgicalId) {
                                        if (surgery.status_id !== 2) { // status_id == 2 -> the service is denied, needs to appear on other majormeds
                                            isDisabled = true
                                        }
                                    }
                                })
                            }
                        }
                    }
                })
            }
        }
       
    }

    return isDisabled
}

export function serviceAlreadyexistsOnOtherWorkersComp(currentWorkersComp, activeCase, departmentId, serviceId) { //NOT needed anymore since there is only one worker comp!!!!
    let isDisabled = false

    if (currentWorkersComp && activeCase && departmentId && serviceId) {
        if (activeCase.worker_comps && activeCase.worker_comps.length > 1) { // if there is just one workers comp, no reason to continue....
            let restOfWorkersComp = activeCase.worker_comps.filter(item => item.id !== currentWorkersComp)

            if (restOfWorkersComp && restOfWorkersComp.length > 0) {
                restOfWorkersComp.forEach(item => {
                    if (item.worker_comp_departments) {                  
                        let sameDepartment = item.worker_comp_departments.find(department => department.department_id == departmentId)
                        if (sameDepartment) { // look into the same department
                   
                            if (sameDepartment.services && sameDepartment.services.length > 0) {
                                sameDepartment.services.forEach(service => {
                                    
                                    if (service.service_id == serviceId) {
                                        if (service.status_id !== 2) { // status_id == 2 -> the service is denied, needs to appear on other majormeds
                                            isDisabled = true
                                        }
                                    }
                                })
                            }
                        }
                    }
                })
            }
        }
       
    }

    return isDisabled
}

export function surgicallreadyexistsOnOtherWorkerComps(currentWorkersComp, activeCase, departmentId, surgicalId) { //NOT needed anymore since there is only one worker comp!!!!
    let isDisabled = false

    if (currentWorkersComp && activeCase && departmentId && surgicalId) {
        if (activeCase.worker_comps && activeCase.worker_comps.length > 1) { // if there is just one major med, no reason to continue....
            let restOfWorkersComp = activeCase.worker_comps.filter(item => item.id !== currentWorkersComp)

            if (restOfWorkersComp && restOfWorkersComp.length > 0) {
                restOfWorkersComp.forEach(item => {
                    if (item.worker_comp_departments) {                  
                        let sameDepartment = item.worker_comp_departments.find(department => department.department_id == departmentId)
                        if (sameDepartment) { // look into the same department
                   
                            if (sameDepartment.surgeries && sameDepartment.surgeries.length > 0) {
                                sameDepartment.surgeries.forEach(surgery => {
                                    
                                    if (surgery.surgery_id == surgicalId) {
                                        if (surgery.status_id !== 2) { // status_id == 2 -> the service is denied, needs to appear on other majormeds
                                            isDisabled = true
                                        }
                                    }
                                })
                            }
                        }
                    }
                })
            }
        }
       
    }

    return isDisabled
}

export function returnPractice(id) {
    let options = practicesOptions()

    if (options) {
        return options.find(item => item.value == id)?.data
    }
   
    return null
}  

export function retriveLienFromPractice(lienArray, type) {
    if (lienArray && type) {
        let lien = lienArray.find(item => item.type == type)
        if (lien) {
            return lien
        }       
    }
    return null
}

function serializeGeocodeResult(result) {
    if (!result) {
        return null
    }

    return {
        formatted_address: result.formatted_address,
        location_type: result.geometry?.location_type,
        lat: result.geometry?.location?.lat(),
        lng: result.geometry?.location?.lng(),
        place_id: result.place_id,
        types: result.types,
        partial_match: result.partial_match || false,
    }
}

function buildLocationTypeSummary(results) {
    const locationTypes = [...new Set(results.map((result) => result.location_type).filter(Boolean))]
    const locationTypeBreakdown = results.reduce((acc, result) => {
        const type = result.location_type || 'UNKNOWN'
        acc[type] = (acc[type] || 0) + 1
        return acc
    }, {})

    const resultsByLocationType = locationTypes.reduce((acc, type) => {
        acc[type] = results.filter((result) => result.location_type === type)
        return acc
    }, {})

    return {
        hasMultipleResults: results.length > 1,
        hasMultipleLocationTypes: locationTypes.length > 1,
        locationTypes,
        locationTypeBreakdown,
        resultsByLocationType,
    }
}

export function geocodeAddressAll(address) {
    return new Promise((resolve) => {
        if (!address) {
            resolve({
                inputAddress: address,
                status: 'NO_ADDRESS',
                resultCount: 0,
                hasMultipleResults: false,
                hasMultipleLocationTypes: false,
                locationTypes: [],
                locationTypeBreakdown: {},
                resultsByLocationType: {},
                results: [],
                firstResultUsedByGetLatitudeLongitude: null,
            })
            return
        }

        if (!window.google?.maps?.Geocoder) {
            resolve({
                inputAddress: address,
                status: 'GOOGLE_MAPS_NOT_LOADED',
                resultCount: 0,
                hasMultipleResults: false,
                hasMultipleLocationTypes: false,
                locationTypes: [],
                locationTypeBreakdown: {},
                resultsByLocationType: {},
                results: [],
                firstResultUsedByGetLatitudeLongitude: null,
            })
            return
        }

        const geocoder = new window.google.maps.Geocoder()

        geocoder.geocode({
            address,
            componentRestrictions: {
                country: 'US',
            },
        }, (results, status) => {
            const serializedResults = (results || []).map(serializeGeocodeResult)
            const locationTypeSummary = buildLocationTypeSummary(serializedResults)

            resolve({
                inputAddress: address,
                status,
                resultCount: serializedResults.length,
                ...locationTypeSummary,
                results: serializedResults,
                firstResultUsedByGetLatitudeLongitude: serializedResults[0] || null,
            })
        })
    })
}

export function getLatitudeLongitude(callback, address, onError) {
    const reportError = (reason) => {
        if (typeof onError === 'function') {
            onError(reason)
        }
    }

    if (!address || !`${address}`.trim()) {
        reportError('empty')
        return
    }

    const geocoder = new window.google.maps.Geocoder();
    if (!geocoder) {
        reportError('unavailable')
        return
    }

    geocoder.geocode({
        'address': address,
        componentRestrictions: {
            country: "US",
        },
    }, function (results, status) {
        if (status == window.google.maps.GeocoderStatus.OK && results?.[0]) {
            if (results[0].partial_match === true) {
                reportError('partial_match');
                return;
            }
            callback(results[0]);
        } else {
            reportError(status);
        }
    });
}

export function objectIsEmpty(obj) {
    return Object.keys(obj).length == 0;
}

export function objectHasOwnProperty(obj, prop) {
    if (obj) {
        return Object.hasOwn(obj, prop)
    }
    
    return false
}

export function isStateOfPip(state) {
    let statesOfPip = stateOfPIPsOptions()

    if (statesOfPip) {
        let foundMatch = statesOfPip.find(item => item.label == state)

        if (foundMatch) {
            return true
        }
    }

    return false
}

function maskify(cc) {
    return cc.slice(0, -4).replace(/./g, '*') + cc.slice(-4);
}

export function hideSSNString(str) {
    if (str != null && `${str}` !== '') {
        const digits = `${str}`.replace(/\D/g, '')
        const lastFour = digits.slice(-4)

        if (lastFour) {
            return `***-**-${lastFour}`
        }

        return maskify(`${str}`)
    }

    return null
}

export function isCasePI(activeCase) {
    let founditem = caseTypeOptions().find(item => item.value == activeCase?.case?.case_type_id) 
    if (founditem) {
        return founditem.category == 'PI'
    }

    return false
}

export function isCaseType(activeCase) {
    let founditem = caseTypeOptions().find(item => item.value == activeCase?.case?.case_type_id) 
    if (founditem) {
        return founditem.category
    }

    return null
}

export function add10yearsFromNow() {
    const futureDate = new Date();
    futureDate.setFullYear(futureDate.getFullYear() + 10);

    return futureDate //?.toLocaleDateString('en-US')
}

export function addNumberOfMonths(startDate, numberOfMonths) {
    if (startDate && numberOfMonths) {
        const date = startDate instanceof Date ? startDate : parseApiDateOrDateTime(startDate);
        if (!date) return null;

        const newDate = new Date(date.getTime());
        newDate.setMonth(date.getMonth() + numberOfMonths);

        return newDate
    }
}

export function capitalizeFirstLetter(val) {
    return String(val).toLowerCase().charAt(0).toUpperCase() + String(val).toLowerCase().slice(1);
}

export function addZero(i) {
  if (i < 10) {i = "0" + i}
  return i;
}

export function totalItemsValue(arr, prop) {
    let total = 0
    if (arr && arr.length > 0 && prop) {
        arr.forEach((item) => {
            const value = Number(item[prop])
            total += Number.isFinite(value) ? value : 0
        })
    }

    return total
}

export function checkIfStringCanBeConvvertedToNumber(text) {
    const num = parseFloat(text);
    return Number.isNaN(num) ? text : num;
}

export function getDateAndTimeInEST(offset) {
    var d = new Date();
    
    const defaultOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        // hour: "2-digit",
        // hour: 'numeric', 
        // hour12: true,
        // minute: "2-digit",
        timeZone: "EST"
    };
    return d.toLocaleString("en-US", defaultOptions)
}

export function checkIfLopIsRequired(atty, activeCase) {
    if (atty && activeCase) {
        if (activeCase.case && activeCase.case.state != 'GA') {
            return true
        }
        if (atty.location) {
            if (atty.location.lop_required) {
                return true
            }
        }
    }

    return false
}

export function checkIfMasterStatusFilterIsSetForAll(filters) {
    if (filters && filters.master_status_id && filters.master_status_id.value == '1,0') {
        return true
    }

    return false
}

export function filterPracticesBasedOnUser(options, user_locations) {
    if (options && user_locations) {
        let arr = []

        options.forEach(opt => {
            if (opt.locations) {

                let filteredOptions = []
                if (user_locations && user_locations.length) {
                    opt.locations.forEach(innerOpt => {
                        if (user_locations.includes(innerOpt.id)) {
                            filteredOptions.push(innerOpt)
                        }
                    })
                } else {
                    filteredOptions = opt.locations
                }
                

                if (filteredOptions && filteredOptions.length) {
                    arr.push({
                        ...opt,
                        options: filteredOptions
                    })
                }
            }
        })


        return arr
    }

    return null
}

export function flagsButtonColor(flags) {
    if (flags) {
        let isOneTrue = null
        for (const [key, value] of Object.entries(flags)) {   
            if (value) {
                isOneTrue = 'btn_orange_header'
            }
        }
        return isOneTrue
    }

    return null
}


export function notesButtonColor(notes) {
    
    if (notes && notes.length) {
        // let tasks = notes.filter(item => (item.is_task && (item.resolved == 0 || item.resolved == null)))

        function isTaskUnresolved(item) {
            if (item.resolved  || item.assignee_resolved) {
                return false
            }
            return true
        }


        let tasks = notes.filter(item => (item.is_task && !item.deleted_at && isTaskUnresolved(item)))

        if (tasks && tasks.length) {
            let arr = [...tasks].sort(function(x, y) {
                return new Date(x.due_date) - new Date(y.due_date)
            });

            let days = getDaysDifference(arr[0].due_date)       

            // if (days <= 0) {
            //     return 'btn_danger'
            // } else if (days <=1) {
            //     return 'btn_orange'
            // } else if (days <=2) {
            //     return 'btn_yellow'
            // } else {
            //     return null
            // }

            if (arr && arr.length) {
                let priority = arr.find(item => item.priority == 'High')

                // if there are unresolved High priority tasks, return red 
                if (priority) {
                    return 'btn_danger_variation'
                }

                // if there are unresolved tasks, if due date is today or in the past, return red
                if (days <= 0) {
                    return 'btn_danger_variation'
                }

                //if there are unresolved tasks, return orange
                return 'btn_orange_header'
            }
        }
    }

    return null
}


export function alertsButtonColor(alerts) {
    if (alerts && alerts.length) {
        let unresolvedAlert = alerts.some(item => !item.resolved)

        if (unresolvedAlert) {
            return 'btn_orange_header'            
        }

        return null
    }

    return null
}

export function traverseObject(item, ignoreFields, specificFields) {
    if (item) {
        let flag = false
        for (const [key, value] of Object.entries(item)) {     
            if (!ignoreFields || (ignoreFields && !ignoreFields.includes(key))) {
                if (specificFields && specificFields.length) {
                    if (specificFields.includes(key)) {
                        if (value) {
                            if (value.constructor == Array ) {
                                if (value.length > 0) {
                                    flag = true
                                }
                            } else {
                                flag = true
                            }
                        }
                    }
                } else {
                    if (value) {
                        if (value.constructor == Array ) {
                            if (value.length > 0) {
                                flag = true
                            }
                        } else {
                            flag = true
                        }
                    }
                }
                
            } 

            //old functionality
            // if (value) {
            //     if (value.constructor == Array ) {
            //         if (value.length > 0) {
            //             flag = true
            //         }
            //     } else {
            //         flag = true
            //     }
            // }
        } 
        return flag
    }

    return false
}

export function isPatientCountySameAsPracticeCounty(activeCase, clinic) {
    if (activeCase && clinic) {
        let patientCounty = activeCase?.patient?.contact_information?.county_id
        let practiceCounty = clinic?.contact_information?.county_id

        if (patientCounty == practiceCounty) {
            return true
        }
    }

    return false
}

export function patientHasCompleteAddress(contact_information) {
    if (contact_information) {
        if (contact_information.address_1 && contact_information.city && contact_information.state && contact_information.zip) {
            return true
        }
    }

    return false
}

export function isPatientStateGeorgia(contact_information) {
    if (contact_information) {
        if (contact_information.state == 'GA') {
            return true
        }
    }

    return false
}

export function canBeDeleted(folder, currentItem, type) {
    if (!currentItem[type]) { // if it is not primary, it can be deleted!
        return {
            deletable: true,
            nextPrimary: null
        }
    } else {
        if (folder) {
            // 3 or more active items => show the message
            if (folder.length > 2) {

                let activeItems = folder.filter(item => item.active && item.id != currentItem.id)

                if (activeItems) { // we have some other active items
                    if (activeItems.length > 1) { // multiple active items, need to show the message!!!
                        return {
                            deletable: false,
                            nextPrimary: null
                        }
                    } else { // there is only one active item, can be deleted, set other item as primary
                        return {
                            deletable: true,
                            nextPrimary: activeItems[0]
                        }
                    }
                }

            } else if (folder.length > 1) { // 2 items
                let otheritem = folder.find(item => item.id != currentItem.id) 

                if (otheritem && otheritem.active) { // if other item is active, can be deleted, set other item as primary
                    return {
                        deletable: true,
                        nextPrimary: otheritem
                    }
                } else { // the other item is not active, just delete.
                    return {
                        deletable: true,
                        nextPrimary: null
                    }
                }
            }
        }
    } 
    


    return {
        deletable: true,
        nextPrimary: null
    }
}


export function isTabActiveAndAccesible(activeTab , tabId, permission_tabs) {
    return activeTab == tabId && permission_tabs.find(item => item.id == tabId)
}

export function makeTotals(arrayData, field, sos, transportation) {
    if (arrayData && field) {
        let initialValue = 0;
        const sumWithInitial = arrayData.reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue[field]),
            initialValue,
        );

        if (sos) {
            initialValue = initialValue + sos
        }

        if (transportation) {
            initialValue = initialValue + transportation
        }

        // return sumWithInitial.toFixed(2)
        return sumWithInitial
    }

    return null
}

function normalizeWorkQueueTeamId(entry) {
    if (entry == null) {
        return null
    }
    if (typeof entry === 'object' && entry !== null && 'id' in entry) {
        return entry.id
    }
    return entry
}

export function filterWorkQByTeams(workQ, user) {
    if (!workQ) {
        return true
    }
    if (!user) {
        return true
    }

    const normalizedWqTeamIds = (workQ.teams || [])
        .map(normalizeWorkQueueTeamId)
        .filter(id => id != null && id !== '')

    if (!normalizedWqTeamIds.length) {
        return !(user.teams && user.teams.length > 0)
    }

    const userWorkQueueTeams = (user.teams || []).filter(team => teamAllowsWorkQueues(team))

    const foundTeam = userWorkQueueTeams.find(item => {
        const uid = normalizeWorkQueueTeamId(item)
        if (uid == null || uid === '') {
            return false
        }
        return normalizedWqTeamIds.some(wqTeamId => wqTeamId == uid)
    })

    return !!foundTeam
}

/** Missing flag (old cached /me) counts as allowed. */
export function teamAllowsWorkQueues(team) {
    if (!team) {
        return false
    }
    return team.allow_work_queues !== false && team.allow_work_queues !== 0
}

/** Missing flag (old cached /me) counts as allowed. */
export function teamAllowsTasks(team) {
    if (!team) {
        return false
    }
    return team.allow_tasks !== false && team.allow_tasks !== 0
}

export function getItemFromIdGeneral(arrayToSearch, id, specificLabel) {
    if (arrayToSearch && id) {
        let found = arrayToSearch.find(item => item.id == id)

        if (specificLabel) {
            if (found) {
                return found[specificLabel]
            }
        } 

        return found
    }
    return null
}

export function isTransferAlowed(practice_id) {
    const practices = practicesOptions()
    
    
    if (practices && practice_id) {
        let foundPractice = practices.find(item => item.value == practice_id)

        if (foundPractice) {
            return foundPractice.allow_transfer ? true : false
        }
    }

    return false
}

export function isDeveloper() {
    let user = getItemFromStorageSimple('user')

    if (user && user.roles && user.roles.length) {
        let developer = user.roles.find(item => item.id == 1)

        if (developer) {
            return true
        }
    }

    return false
}

export function isDeveloperOrMoonBird() {
    let user = getItemFromStorageSimple('user')

    if (user && user.roles && user.roles.length) {
        let developer = user.roles.find(item => item.id == 1 || item.id == 9)

        if (developer) {
            return true
        }
    }

    return false
}

export function caseTypeListIncludes(caseTypes, caseTypeId) {
    if (caseTypeId == null || caseTypeId === '') return false;
    if (!Array.isArray(caseTypes) || caseTypes.length === 0) return false;
    return caseTypes.some((ct) => ct == caseTypeId);
}

export function filterPayerTypesForCaseType(payerTypes, caseTypeId) {
    if (!Array.isArray(payerTypes)) return [];
    const allowedForCaseType = payerTypes.filter((item) =>
        caseTypeListIncludes(item.case_types, caseTypeId),
    );
    const unrestricted = payerTypes.filter(
        (item) => !item.case_types || item.case_types.length === 0,
    );
    const merged = [...allowedForCaseType, ...unrestricted];
    return merged.filter(
        (item, index, arr) => arr.findIndex((o) => o.value == item.value) === index,
    );
}

export function findPayerTypeSetting(payerTypes, payerTypeId) {
    if (payerTypeId == null || payerTypeId === '') return null;
    if (!Array.isArray(payerTypes)) return null;
    return payerTypes.find((item) => item.value == payerTypeId || item.id == payerTypeId) ?? null;
}

export function isPayerTypeMismatchedForCaseType(payerTypeId, caseTypeId, payerTypes) {
    if (payerTypeId == null || payerTypeId === '') return false;
    if (caseTypeId == null || caseTypeId === '') return false;

    const payerType = findPayerTypeSetting(payerTypes, payerTypeId);
    if (!payerType) return true;

    if (!payerType.case_types || payerType.case_types.length === 0) return false;

    return !caseTypeListIncludes(payerType.case_types, caseTypeId);
}

export function getPayerTypeSettingLabel(payerTypes, payerTypeId) {
    const payerType = findPayerTypeSetting(payerTypes, payerTypeId);
    return payerType?.label ?? payerType?.name ?? '';
}

export function isMismatchedOption(id, options) {
    if (id && options) {
        let foundOption = options.find(item => item.value == id)

        if (!foundOption) {
            return true
        }
    }

    return false
}

export function buildRows(numberOfRows) {
    const mockRows = [];
    if (numberOfRows) {
        for (let i = 0; i < numberOfRows; i++) {
            mockRows.push({ id: i });
        }
        return mockRows;
    }

    return null
}

 // Helper to turn an object like {"date": num, ...} into an array [{date, value}, ...]
export function objectToArray(obj) {
    return Object.entries(obj || {}).map(([date, value]) => ({ date, value }));
}

export function objectToArrayWithKey(obj) {
    return Object.entries(obj || {}).map(([key, value]) => ({ key, value }));
}

export function formatNumber(num) {
    if (num === null || num === undefined || isNaN(num)) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function reduceToIdArray(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map(item => item && typeof item === 'object' && 'id' in item ? item.id : item);
}

export function reduceToArraySpecificField(arr, field) {
    if (!Array.isArray(arr)) return [];
    return arr.map(item => item && typeof item === 'object' && field in item ? item[field] : item);
}

export function caseHaseRides(case_transportation) {
    if (case_transportation) {
        if (case_transportation.rides && case_transportation.rides.length) {
            let activeItem = case_transportation.rides.find(item => item.active)

            if (activeItem) {
                return true
            }
        }

        
    }

    return false
}

export function isThisACase(activeCase) {
    if (activeCase && activeCase.case) {
        if (activeCase.case.is_case == 1) {
            return true
        } else if (activeCase.case.is_case == 0) {
            return false
        }
    }

    return null
}